module.exports = __webpack_public_path__ + "/login_ui/img/mc-f1916538fecc62bfb276ed4af4b4213b.svg";